import { render } from "./AwsTop.vue?vue&type=template&id=03a3a5c8"
import script from "./AwsTop.vue?vue&type=script&lang=js"
export * from "./AwsTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__